import { defineComponent as _defineComponent } from 'vue'
import { formatPrice } from '@white-label-helper/helper-payment';
import {
  TravelInsuranceQuoteDetails
} from 'feature-shared-organisms';



export default /*#__PURE__*/_defineComponent({
  __name: 'product-summary-travel-insurance-card',
  props: {
    product: null
  },
  setup(__props: any) {




return { __sfc: true,formatPrice, TravelInsuranceQuoteDetails }
}

})